import { render } from "./publish-call-for-tenders.svg?vue&type=template&id=004d0a2b"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__